<div
  class="tag"
  [class]="{
    'green': value,
    'red': !value,
  }"
>
  <span>{{ value ? "Paid" : "Unpaid" }}</span>
</div>
